//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('docArticleSearch', {
//        templateUrl: 'views/components/views/docArticleSearch/docArticleSearch.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'docArticleSearchService', 'rememberService', function (stateService, utilityService, docArticleSearchService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            let variableNames = {
//                searchtext: ''
//            };

//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') },
//                    { id: 'search', icon: 'glyphicon glyphicon-search', color: 'primary', type: 'primary', onClick: () => searchDocumentArticles() }
//                ],
//    			setting: {},
//    			itemsListDocumentArticles: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await docArticleSearchService.getSetting())[0];
//            }
            
//            async function loadDocumentArticles() {
//                if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                vm.model.itemsListDocumentArticles = [];
                
//                return vm.model.itemsListDocumentArticles = await docArticleSearchService.listDocumentArticles({ searchtext: vm.model.setting.searchtext });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region CLEAR BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        if (vm.model.setting.searchtext === '') {
//                            rememberFunc('searchtext');

//                            vm.model.itemsListDocumentArticles = [];
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion CLEAR BUTTON FUNCTION

//            // #region SEARCH FUNCTIONS

//            function searchDocumentArticles() {
//                if (vm.model.setting.searchtext > '') {
//                    rememberFunc('searchtext');
//                    loadDocumentArticles();
//                }
//            }

//            vm.searchItems = function () {
//                searchDocumentArticles();
//            }

//            // #endregion SEARCH FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') {
//                            rememberFunc('searchtext');

//                            vm.model.itemsListDocumentArticles = [];
//                        }
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ANGULAR CYCLE FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadDocumentArticles();
//            }

//            // #endregion ANGULAR CYCLE FUNCTION

//        }]
//    });
//})();
